import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CPUComponent } from './cpu/cpu.component';
import { GPUComponent } from './gpu/gpu.component';
import { ScreenshareComponent } from './screenshare/screenshare.component';

@Component({
  selector: 'app-test',
  imports: [MatTabsModule, CPUComponent, GPUComponent, ScreenshareComponent],
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent {
  activeTab = 0;

  constructor() {}

  onTabChange(event: any) {
    this.activeTab = event.index;
  }
}
